/**
 * Techwall Klaviyo profile sync (storefront beacon only).
 * Calls the secured Techwall server endpoint. Never calls Klaviyo private APIs.
 * Failures are swallowed so Shopify forms are never blocked.
 */
(function () {
  var PENDING_KEY = 'twl_klaviyo_pending_v1';
  var INIT_FLAG = '__twlKlaviyoSyncInit';
  var LEAD_FORM_IDS = ['ContactForm', 'VisitForm'];
  var ATTR_KEY = 'twl_ft_attr_v1';

  function readJson(storage, key) {
    try {
      var raw = storage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (err) {
      return null;
    }
  }

  function writeJson(storage, key, value) {
    try {
      storage.setItem(key, JSON.stringify(value));
      return true;
    } catch (err) {
      return false;
    }
  }

  function readConfig() {
    var node = document.getElementById('twl-klaviyo-sync-config');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (err) {
      return null;
    }
  }

  function fieldValue(formId, suffix) {
    var el = document.getElementById(formId + suffix);
    return el && el.value ? String(el.value).trim() : '';
  }

  function hiddenPersistValue(form, name) {
    if (!form) return '';
    var input = form.querySelector('input[name="contact[' + name + ']"]');
    return input && input.value ? String(input.value).trim() : '';
  }

  function firstTouchSnapshot() {
    return readJson(localStorage, ATTR_KEY) || {};
  }

  function formTypeFor(formId) {
    if (formId === 'VisitForm') return 'consultation';
    return 'contact';
  }

  function buildPending(form) {
    if (!form || !form.id) return null;
    if (LEAD_FORM_IDS.indexOf(form.id) === -1) return null;
    var email = fieldValue(form.id, '-email');
    if (!email) return null;
    var attr = firstTouchSnapshot();
    var leadId = hiddenPersistValue(form, 'twl_lead_id');
    return {
      form_type: formTypeFor(form.id),
      email: email,
      twl_lead_id: leadId,
      twl_company: fieldValue(form.id, '-company'),
      twl_role: fieldValue(form.id, '-job-role'),
      twl_country: fieldValue(form.id, '-country'),
      twl_gclid: hiddenPersistValue(form, 'twl_gclid') || attr.gclid || '',
      twl_gbraid: hiddenPersistValue(form, 'twl_gbraid') || attr.gbraid || '',
      twl_wbraid: hiddenPersistValue(form, 'twl_wbraid') || attr.wbraid || '',
      twl_utm_source: hiddenPersistValue(form, 'twl_utm_source') || attr.utm_source || '',
      twl_utm_medium: hiddenPersistValue(form, 'twl_utm_medium') || attr.utm_medium || '',
      twl_utm_campaign: hiddenPersistValue(form, 'twl_utm_campaign') || attr.utm_campaign || '',
      twl_utm_term: hiddenPersistValue(form, 'twl_utm_term') || attr.utm_term || '',
      twl_utm_content: hiddenPersistValue(form, 'twl_utm_content') || attr.utm_content || '',
      twl_landing_page: hiddenPersistValue(form, 'twl_landing_page') || attr.landing_page || '',
      twl_original_referrer:
        hiddenPersistValue(form, 'twl_original_referrer') || attr.original_referrer || '',
      twl_submitted_at: new Date().toISOString()
    };
  }

  function sendPayload(config, payload) {
    if (!config || !config.endpoint || !config.token) return;
    try {
      fetch(config.endpoint, {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
          authorization: 'Bearer ' + config.token
        },
        body: JSON.stringify(payload),
        keepalive: true,
        credentials: 'omit'
      }).catch(function () {});
    } catch (err) {}
  }

  function onFormSubmit(event) {
    try {
      var form = event && event.currentTarget;
      var pending = buildPending(form);
      if (pending) writeJson(sessionStorage, PENDING_KEY, pending);
    } catch (err) {}
  }

  function bindLeadForms() {
    var i;
    for (i = 0; i < LEAD_FORM_IDS.length; i++) {
      var form = document.getElementById(LEAD_FORM_IDS[i]);
      if (!form || form.getAttribute('data-twl-klaviyo-bound') === 'true') continue;
      form.addEventListener('submit', onFormSubmit);
      form.setAttribute('data-twl-klaviyo-bound', 'true');
    }
  }

  function readInquiryState() {
    var node = document.getElementById('twl-inquiry-form-state');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (err) {
      return null;
    }
  }

  function readNewsletterState() {
    var node = document.getElementById('twl-newsletter-sync-state');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (err) {
      return null;
    }
  }

  function flushInquirySync(config) {
    var state = readInquiryState();
    if (!state || !state.postedSuccessfully || state.hasErrors) return;
    var pending = readJson(sessionStorage, PENDING_KEY);
    if (!pending) return;
    sendPayload(config, pending);
    try {
      sessionStorage.removeItem(PENDING_KEY);
    } catch (err) {}
  }

  function flushNewsletterSync(config) {
    var state = readNewsletterState();
    if (!state || !state.postedSuccessfully || !state.email) return;
    sendPayload(config, {
      form_type: 'newsletter',
      email: state.email,
      twl_submitted_at: new Date().toISOString()
    });
  }

  function init() {
    if (window[INIT_FLAG]) return;
    window[INIT_FLAG] = true;
    var config = readConfig();
    bindLeadForms();
    flushInquirySync(config);
    flushNewsletterSync(config);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
